// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8139b7db","239":"bb759aba","453":"ecd4a964","633":"602983d7","732":"d72ac87f"}[chunkId] + ".chunk.js";
};